var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"loading",staticClass:"zoox-loader",style:({height: _vm.size + 'px', width: _vm.size + 'px'})},[_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"zoox-loader-container"},[_c('div',[_c('div')]),_c('div',[_c('div')]),_c('div',[_c('div')]),_c('div',[_c('div')]),_c('div',[_c('div')]),_c('div',[_c('div')]),_c('div',[_c('div')]),_c('div',[_c('div')])])
}]

export { render, staticRenderFns }